
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/coupons",
      function () {
        return require("private-next-pages/[lang]/coupons.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/coupons"])
      });
    }
  